import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import styles from './overlay.module.css';
import ModalCloseButton from '../ModalCloseButton';
import { Autocomplete } from '@mui/material';
import TextField from '@mui/material/TextField';
import Chip from '@mui/material/Chip';
import useAxiosPrivate from "../../../utils/hooks/useAxiosPrivate";
import Alert from '@material-ui/lab/Alert';
import { ReactComponent as AddDevice } from '../../../utils/assets/add devices.svg';
import { withStyles } from '@material-ui/core/styles';

const CssTextField = withStyles({
    root: {
        "& label.Mui-focused": {
            color: "#0F9BB0"
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: "#0F9BB0"
        },
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: "#0F9BB0"
            },
            "&:hover fieldset": {
                borderColor: "#0F9BB0"
            },
            "&.Mui-focused fieldset": {
                borderColor: "#0F9BB0"
            }
        },
        "& .MuiFormLabel-root.Mui-error": {
            color: "gray !important",
        },
        "& .MuiFormHelperText-root.Mui-error": {
            color: "red !important"
        },
        "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: "black",
            color: "black"
        }
    },
})(TextField);

// import { useNavigate } from 'react-router-dom';
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <ModalCloseButton onClick={onClose} />
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function AddUser() {
  const axios = useAxiosPrivate()
  const [open, setOpen] = React.useState(false);
  const [emails, setEmails] = React.useState([]);
  const [emailsValidation, setEmailsValidation] = useState([]);
  // let navigate = useNavigate();

  const [alert, setAlert] = useState({
    showAlert: false,
    severity: 'success',
    message: '',
  });
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const addEmails = (arr) => {
    let testArray = [];
    setEmails(arr);
    arr.map((item) => {
      const result = checkEmail(item);
      if (result) {
        return testArray.push(true);
      } else {
        return testArray.push(false);
      }
    })
    setEmailsValidation(testArray);
  };

  const sendInvite = () => {
    if (emails.length === 0) {
      setAlert({
        showAlert: true,
        severity: 'error',
        message: 'Please enter an email address and press ENTER to invite.',
      });
      setTimeout(() => {
        setAlert({
          showAlert: false,
          severity: 'error',
          message: 'Please enter an email address and press ENTER to invite.',
        });
      }, 5000);
    }
    emails.map(async (item) => {
      try {
        await axios.post('/team/invite', {
          email: item,
        });
        // navigate('/dashboard');
        window.location.href = '/dashboard';
        setAlert({
          showAlert: true,
          severity: 'Success',
          message: 'Sent invite Successfully!',
        });
        setTimeout(() => {
          setAlert({
            showAlert: false,
            severity: 'Success',
            message: 'Sent invite Successfully!',
          });
          handleClose();
        }, 5000);
      } catch (error) {
        if (error.response.status === 401) {
          setAlert({
            showAlert: true,
            severity: 'error',
            message: 'Invalid Authentication!',
          });
          setTimeout(() => {
            setAlert({
              showAlert: false,
              severity: 'error',
              message: 'Invalid Authentication!',
            });
          }, 5000);
        } else if (error.response.status === 404) {
          setAlert({
            showAlert: true,
            severity: 'error',
            message: 'User not found.!',
          });
          setTimeout(() => {
            setAlert({
              showAlert: false,
              severity: 'error',
              message: 'User not found.!',
            });
          }, 5000);
        } else if (error.response.status === 400) {
          setAlert({
            showAlert: true,
            severity: 'error',
            message: 'Invalid email!',
          });
          setTimeout(() => {
            setAlert({
              showAlert: false,
              severity: 'error',
              message: 'Invalid email!',
            });
          }, 5000);
        } else {
          setAlert({
            showAlert: true,
            severity: 'error',
            message: 'Server error!',
          });
          setTimeout(() => {
            setAlert({
              showAlert: false,
              severity: 'error',
              message: 'Server error!',
            });
          }, 5000);
        }
      }
    });
  };
  const checkEmail = (address) => {
    let regex = new RegExp(
      // eslint-disable-next-line
      "([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|\"([]!#-[^-~ \t]|(\\[\t -~]))+\")@([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|[[\t -Z^-~]*])"
    );
    const result = regex.test(address);

    return result
  };

  return (
    <div>
      <div
        style={{ display: 'flex', alignItems: 'center' }}
        onClick={handleClickOpen}
      >
        {/* <img
            src={Device}
            width='30'
            height='30'
            alt='Device'
            style={{margin: '0 0 0 1rem'}}
        /> */}
        <AddDevice
          className={
            open ? `${styles.navIcon} ${styles.navIconActive}` : styles.navIcon
          }
        />
      </div>
      <BootstrapDialog
        maxWidth='lg'
        fullWidth
        onClose={handleClose}
        aria-labelledby='customized-dialog-title'
        open={open}
      >
        <BootstrapDialogTitle
          id='customized-dialog-title'
          onClose={handleClose}
        ></BootstrapDialogTitle>
        <DialogContent>
          <p className={styles.headerText}>Invite Patients</p>
          <div className={styles.inviteRow}>
            <Autocomplete
              multiple
              freeSolo
              fullWidth
              onChange={(event, newValue) => {
                addEmails(newValue);
              }}

              options={[]}
              getOptionLabel={(option) => option}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <>
                    {checkEmail(option) ? (
                      <div className={styles.emailChip}>
                        <Chip
                          style={{
                            fontFamily: 'normal normal normal 12px Poppins',
                            letterSpacing: '0px',
                            background: '#ECF9F7 0% 0% no-repeat padding-box',
                            color: '#000000',
                            opacity: 1,
                            flexWrap: 'wrap',
                            fontWeight: 400,
                            fontSize: '1rem',
                            lineHeight: '1.37rem',
                            height: "2rem"
                          }}
                          key={index}
                          size='small'
                          label={option}
                          {...getTagProps({ index })} d
                        />
                      </div>
                    ) : (
                      <div className={styles.errorChip}>
                        <Chip
                          style={{
                            fontFamily: 'normal normal normal 12px Poppins',
                            letterSpacing: '0px',
                            background: '#ffffff 0% 0% no-repeat padding-box',
                            color: '#000000',
                            opacity: 1,
                            flexWrap: 'wrap',
                            fontWeight: 400,
                            fontSize: '1rem',
                            lineHeight: '1.37rem',
                            height: "1.5rem"
                          }}
                          key={index}
                          size='small'
                          label={option}
                          {...getTagProps({ index })}
                        />
                      </div>
                    )}
                  </>
                ))
              }
              renderInput={(params) => (
                <CssTextField
                  placeholder={
                    params ? 'Insert email to add patients, divide by enter' : ''
                  }
                  {...params}
                />
              )}
            />
            <input
              type='button'
              className={
                emails.length > 0 && !emailsValidation.includes(false) ? styles.searchButton : styles.disabled
              }
              value='Send Invite'
              onClick={emails.length > 0 && !emailsValidation.includes(false) ? sendInvite : null}
            />
          </div>
          {alert.showAlert && (
            <div style={{ padding: '0.5rem 2rem' }}>
              <Alert
                severity={alert.severity}
                onClose={() =>
                  setAlert({
                    ...alert,
                    showAlert: false,
                  })
                }
              >
                {alert.message}
              </Alert>
            </div>
          )}
          <p className={styles.descriptionText}>
            Visit Patients to remove patients and check their status.{' '}
          </p>
        </DialogContent>
      </BootstrapDialog>
    </div>
  );
}
